// extracted by mini-css-extract-plugin
module.exports = {"tag":"NoteTags_tag__2MJBf"};